import { useEffect, useState } from "react";
import AdmsIdentifierList from "./AdmsIdentifierList";

const useFormSchema = (initialFormData, onIdentifiersChange, onSnackbarMessage=null, onClearValidationError = null) => {
  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    setFormData(initialFormData);
  }, [initialFormData]);

  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  // Generic handler for fields
  const handleFieldChange = (fieldName, updatedValues) => {
    // console.log(`${fieldName} updated:`, updatedValues);
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: updatedValues,
    }));
  };

  const handleIdentifierChange = (updatedIdentifiers) => {
    // console.log("Identifiers updated:", updatedIdentifiers); // Should show array of AdmsIdentifier
    // If you're setting the form data and want to keep it as flat as possible:
    setFormData((prevData) => ({
      ...prevData,
      identifier: new AdmsIdentifierList(updatedIdentifiers), // Keep it as an array of identifiers
    }));

    if (onIdentifiersChange) {
      onIdentifiersChange(updatedIdentifiers); // Pass plain array
    }
  };

  const handleAddressChange = (field, updatedAddress) => {
    // console.log(field, updatedAddress);
    setFormData((prevData) => ({
      ...prevData,
      [field]: updatedAddress,
    }));
  };

  const handlePersonChange = (personType, updatedPerson) => {
    // console.log(personType, updatedPerson);
    setFormData((prevData) => ({
      ...prevData,
      [personType]: updatedPerson,
    }));
  };

  const handleLogoUpload = (fileItems) => {
    // fileItems is an array of files being processed by FilePond
    if (fileItems.length > 0) {
      // If there are files uploaded, get the file object
      const uploadedLogo = fileItems[0].file;
      setFormData({ ...formData, logo: uploadedLogo });
    } else {
      setFormData({ ...formData, logo: "" });
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (onClearValidationError) {
      onClearValidationError();
    }
    if (file) {
      try {
        let text = await file.text(); // Read the file content
        text = text.replace(/(\r\n|\n|\r)/gm, ""); // Clean up newlines
        setFormData((prevData) => ({
          ...prevData,
          certificate: text, // Set certificate to file content
        }));
        if (onSnackbarMessage) {
          onSnackbarMessage("File uploaded successfully.", "success");
        }
      } catch (error) {
        console.error("File reading error:", error);
        if (onSnackbarMessage) {
          onSnackbarMessage("Failed to read file.", "error");
        }
      }
    } else {
      if (onSnackbarMessage) {
        onSnackbarMessage("Please upload a valid file.", "error");
      }
    }
  };

  return { formData, handleChange, handleIdentifierChange, handleAddressChange, handlePersonChange, handleFieldChange, handleLogoUpload, handleFileUpload};
};

export default useFormSchema;
